import './ButtonStyles.scss';

const Button = (props) => {
  return (
    <button {...props} className={`${props.variant} font-bold uppercase`}>
      {props.text}
    </button>
  );
};

export default Button;
